export default function setIntersection<T>(setA: Set<T>, setB: Set<T>): Set<T> {
  return new Set(Array.from(setA).filter((value) => setB.has(value)));
}
